import {Component, Input} from '@angular/core';
import {ShoppingModel} from '../../models/shopping.model';
import {Router} from '@angular/router';
import {UtilityService} from '../core/utils.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AuthenticationService} from '@app/core/authentication/authentication.service';

@Component({
  selector: 'app-shopping-lateral-menu',
  templateUrl: './shopping-lateral-menu.component.html',
  styleUrls: ['./shopping-lateral-menu.component.scss']
})
export class ShoppingLateralMenuComponent {

  @Input()
  shopping: ShoppingModel;

  @Input()
  selectedMenu: string;

  menuOpened: any = false;

  constructor(
    private router: Router,
    private util: UtilityService,
    private authenticationService: AuthenticationService,
    private modalService: NgbModal) {
    util.isMenuOpened().subscribe(menuOpened => {
      this.menuOpened = menuOpened;
    });
  }

  toggleMenu() {
    this.util.toggleMenu();
  }

  openMenu(linkName: string) {
    this.toggleMenu();
    if (this.authenticationService.credentials) {
      const link = `/shopping/${this.shopping.id_hash}/${linkName}`;
      this.router.navigate([link]);
      return;
    }
    this.util.openLoginModal(this.modalService, null);
  }

  logout() {
    this.toggleMenu();
    const logoutFn = this.authenticationService.logout();
    logoutFn.subscribe(() => this.router.navigate(['/login'], { replaceUrl: true }),  () => {
      this.router.navigate(['/login'], { replaceUrl: true });
    });
  }

  get username(): string | null {
    const credentials = this.authenticationService.credentials;
    return credentials ? credentials.username : null;
  }
}



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/shopping-lateral-menu/shopping-lateral-menu.component.ts